/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forbiddenerror1Inputs */

const en_forbiddenerror1 = /** @type {(inputs: Forbiddenerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access forbidden.`)
};

const de_forbiddenerror1 = /** @type {(inputs: Forbiddenerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriff verweigert.`)
};

/**
* | output |
* | --- |
* | "Access forbidden." |
*
* @param {Forbiddenerror1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const forbiddenerror1 = /** @type {((inputs?: Forbiddenerror1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forbiddenerror1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forbiddenerror1(inputs)
	return de_forbiddenerror1(inputs)
});
export { forbiddenerror1 as "forbiddenError" }